import { Tooltip } from 'antd'
import { FlagOutlined, FlagFilled } from '@ant-design/icons'
import { MarkTrigger } from './styles'

const ClientSubmissionMark = mediaProps => {
  const {
    answerId,
    questionId,
    enrollmentId,
    productId,
    typeOfQuestion,
    url,
    clientSubmission,
    promotionalPackage,
    promotionalComment = '',
    onSaveMediaMark,
    tooltipTitle = 'Mark this entry for client submission'
  } = mediaProps

  return (
    <Tooltip title={tooltipTitle}>
      <MarkTrigger
        className={clientSubmission ? 'marked' : undefined}
        onClick={() =>
          onSaveMediaMark({
            answerId,
            questionId,
            enrollmentId,
            productId,
            typeOfQuestion,
            url,
            clientSubmission: !clientSubmission,
            promotionalPackage: !!promotionalPackage,
            promotionalComment
          })
        }
      >
        {clientSubmission ? <FlagFilled /> : <FlagOutlined />}
      </MarkTrigger>
    </Tooltip>
  )
}

export default ClientSubmissionMark
